import React from 'react';
import Component from 'BaseComponent';
import Select from 'form/Select';
import countryCodes from 'iso-3166-country-list';

export default class CountrySelect extends Component {

  render() {
    const options = countryCodes.map(({ code, name }) => ({ label: name, value: code }));
    return (
      <Select
        {...this.props}
        clearable={false}
        options={options}
      />
    );
  }
}




// WEBPACK FOOTER //
// ./app/components/CountrySelect.jsx